<template>
  <div class="tagsArea">
    <div class="title">
      {{ $t('detail.tags') + ' & ' + $t('detail.management') }}
    </div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </template>

      <input-tags v-model="localTags">
        <div
          class="tags-input"
          slot-scope="{ tag, removeTag, inputEventHandlers, inputBindings }"
        >
          <div v-for="tag in localTags" class="tags-input-tag">
            <div>{{ tag.name }}</div>
            <button
              type="button"
              class="tags-input-remove"
              @click="removeTagItem(tag)"
            >
              <a class="icon-button danger" href="javascript:;">
                <i class="far fa-times-circle"></i>
              </a>
            </button>
          </div>
          <div class="add-tag">
            <i class="far fa-plus-circle"></i>
            <input
              class="tags-input-text"
              v-model="tagInput"
              :placeholder="$t('detail.addTag')"
              v-on:keyup.enter="insertTagItem"
            />
            <!-- v-on="inputEventHandlers" -->
          </div>
        </div>
      </input-tags>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'

export default {
  name: 'TagList',
  props: {
    tags: Object | Array,
    vmId: String,
  },
  data() {
    return {
      loading: false,
      tagInput: '',
      localTags: [],
    }
  },
  created() {
    this.setTags()
  },
  methods: {
    setTags() {
      this.localTags = this.tags
    },
    removeTagItem(tag) {
      if (tag) {
        this.loading = true
        ApiService.delete(`iaas/virtual-machines/${this.vmId}/tags/${tag.slug}`)
          .then(({ data }) => {
            let index = this.localTags.findIndex((f) => f.slug == tag.slug)
            this.localTags.splice(index, 1)
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    insertTagItem() {
      if (this.tagInput) {
        this.loading = true
        let params = {
          name: this.tagInput,
        }

        ApiService.post(`iaas/virtual-machines/${this.vmId}/tags`, params)
          .then(({ data }) => {
            this.$generateToast(this, 'success', this.$t('global.successful'))
            this.tagInput = ''
            this.localTags = data.data.tags.data
          })
          .catch((err) => {
            this.$generateToast(this, 'danger', err.message, true)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
  watch: {
    tags() {
      this.setTags()
    },
  },
}
</script>

<style lang="scss" scoped>
.tagsArea {
  width: 100%;
  padding: 20px;
  border-top: 1px solid #eeeff3;
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: #212121;
    margin-bottom: 10px;
  }
  .tags-input {
    .tags-input-tag {
      position: relative;
      display: inline-block;
      background: #456dea;
      border-radius: 6px;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0.03em;
      color: #ffffff;
      padding: 8px 25px;
      margin-right: 20px;
      margin-bottom: 5px;

      .tags-input-remove {
        display: none;
        position: absolute;
        top: 7px;
        right: 4px;
        i {
          color: #fff;
          border-radius: 4px;
          font-size: 16px;
          line-height: 14px;
          padding-top: 3px;
        }
      }
      &:hover {
        .tags-input-remove {
          display: inherit;
        }
      }
    }
    .add-tag {
      position: relative;
      display: inline-block;
      i {
        color: #456dea;
        position: absolute;
        top: 9px;
        left: 15px;
      }
      .tags-input-text {
        height: 34px;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.03em;
        color: #456dea;
        padding: 8px 20px 8px 40px;
        background: #ffffff;
        border: 1px dashed #456dea;
        box-sizing: border-box;
        border-radius: 6px;
        width: 150px;
        outline: none;

        &::placeholder {
          color: #456dea;
        }

        &:focus {
          color: #464e5f;
          border: 1px dashed #fff;
          width: 100%;
        }
      }
      &:focus {
        i {
          color: #464e5f;
        }
      }
    }
  }
}
</style>
